module.exports = __webpack_public_path__ + "files/44a34b1fe08e4ee0cee1ed666b7d0028.mp3";